import { useCallback } from 'react';

import { useRouteActions } from '@confluence/route-manager/entry-points/RouteState';
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance';
import { expValEquals } from '@confluence/feature-experiments';

type navigationOptions = {
	openContentInNewTab?: boolean;
	isReplaceAction?: boolean;
	forceReload?: boolean;
};

type useNavigationResult = (url: string, options?: navigationOptions) => void;

export const useNavigation = (): useNavigationResult => {
	const { push, replace } = useRouteActions();

	return useCallback(
		(url: string, options?: navigationOptions) => {
			const { openContentInNewTab, isReplaceAction, forceReload } = options || {};

			// Track when we're navigating after template creation.
			// URL format: /wiki/spaces/{space}/pages/edit-v2/{contentId}?params
			if (expValEquals('platform_editor_template_creation_ufo_attribute', 'isEnabled', true)) {
				// Extract contentId as last path segment before query params
				const contentId = url.split('?')[0].split('/').pop();

				// Check our contentId is numerical, and not accidentally something else.
				if (contentId && /^\d+$/.test(contentId)) {
					localStorage.setItem(`page-created-from-template-${contentId}`, Date.now().toString());
				}
			}

			if (openContentInNewTab) {
				window.open(url, '_blank', 'noreferrer');
			} else if (isReplaceAction) {
				replace(url, forceReload);
			} else {
				push(url, forceReload);
			}
		},
		[push, replace],
	);
};
